import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServiceCard = ({
    title,
    description,
    icon,
    linkTo = "/services",
    delay = 0
}) => {
    return (
        <motion.div
            className="bg-white rounded-xl p-6 border border-gray-200 shadow-lg hover:shadow-xl flex flex-col h-80 w-full"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            whileHover={{
                scale: 1.05,
                y: -5
            }}
            transition={{
                duration: 0.8,
                delay: delay,
                ease: "easeOut",
                scale: { duration: 0.15, ease: "easeOut" },
                y: { duration: 0.15, ease: "easeOut" }
            }}
        >
            <div className="text-center flex-1 flex flex-col justify-between h-full">
                <div className="space-y-4">
                    <div className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mx-auto">
                        {icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">{title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                        {description}
                    </p>
                </div>
                <Link
                    to={linkTo}
                    className="inline-flex items-center justify-center bg-brand-orange text-white px-6 py-3 rounded-lg font-semibold hover:bg-brand-orange-hover hover:scale-105 transition-all duration-300 text-sm mt-4"
                >
                    Explore Service
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </Link>
            </div>
        </motion.div>
    );
};

export default ServiceCard;
